export const LOCATION_LOAD = 'locate/LOCATION_LOAD';
export const LOCATION_LOAD_SUCCESS = 'locate/LOCATION_LOAD_SUCCESS';
export const LOCATION_CHANGE = 'locate/LOCATION_CHANGE';
export const LOCATION_CHANGE_SUCCESS = 'locate/LOCATION_CHANGE_SUCCESS';
export const LOCATION_USER_SET = 'locate/LOCATION_USER_SET';
export const LOCATION_LOAD_LINKS = 'locate/LOCATION_LOAD_LINKS';
export const LOCATION_LOAD_LINKS_SUCCESS = 'locate/LOCATION_LOAD_LINKS_SUCCESS';
export const LOCATION_LOAD_LINKS_ERROR = 'locate/LOCATION_LOAD_LINKS_ERROR';
export const LOCATION_TOOGLE_EDIT = 'locate/LOCATION_TOOGLE_EDIT';
